import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import _ from 'underscore';
import { titleize, humanize, unescapeHTML } from 'underscore.string';
import moment from 'moment';
import accounting from 'accounting';
import { decode } from 'he';
import AppointmentConfirmationBadge from 'components/modules/shipments/stops/AppointmentConfirmationBadge';
import ShipmentListDocuments from 'components/modules/shipments/tracking/ShipmentListDocuments';
import { Translation, useTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import formatMoney from 'utils/formatters/Money';
import i18next from 'i18next';
import { getTimeZoneName } from 'utils/Timezones';
import Badge from '../v2/Badge';
import { getLocationTimezone } from '../../helpers/locations';
import { getPickupStop, getDeliverStop } from '../../helpers/stops';
import { canEditAppointmentWindow } from '../../helpers/shipments';
import { isIntermodalShipmentType } from '../../helpers/shipment-types';
import { LoadUnitFormatter, LoadDimensionFormatter, } from '../modules/master/formatters';
import ExternalLink from '../v2/ExternalLink';
import { isArrayOfStrings } from 'utils/string-util';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import { mapTags } from 'utils/formatters/tags';
export const shipperCostFormatter = (cell, row) => {
    if (!row.receivables.length) {
        return React.createElement("span", null, formatMoney(cell, row === null || row === void 0 ? void 0 : row.currency));
    }
    // Calculate Drayage Total
    const recTotal = row.receivables.reduce((total, ledgerItem) => total + ((ledgerItem === null || ledgerItem === void 0 ? void 0 : ledgerItem.value) || 0), 0);
    return React.createElement("span", null, formatMoney(recTotal, row === null || row === void 0 ? void 0 : row.currency));
};
export const carrierPayoutFormatter = (cell, row) => {
    if (!row.payables.length) {
        return React.createElement("span", null, formatMoney(cell, row === null || row === void 0 ? void 0 : row.currency));
    }
    const payableTotal = row.payables.reduce((total, ledgerItem) => total + ((ledgerItem === null || ledgerItem === void 0 ? void 0 : ledgerItem.value) || 0), 0);
    return React.createElement("span", null, formatMoney(payableTotal, row === null || row === void 0 ? void 0 : row.currency));
};
export const exceptionReporterFormatter = (cell) => {
    if (cell === 'cargomatic-automation') {
        return (React.createElement("img", { alt: "cargomatic-automation", src: "/img/storm-trooper.jpg", className: "icon", width: "25" }));
    }
    return React.createElement("span", null, cell);
};
export const currencyFormatter = (cell, row) => (React.createElement("span", null, formatMoney(cell, row === null || row === void 0 ? void 0 : row.currency)));
export const headerFormatter = (column, colIndex, { sortElement }) => {
    const { t } = useTranslation();
    let display_text = column.headerText || column.text;
    if (column.localizationSlug) {
        display_text = titleize(t(column.localizationSlug, {
            count: column === null || column === void 0 ? void 0 : column.count,
        }));
    }
    if (column.titleize)
        display_text = titleize(display_text);
    return (React.createElement("div", { className: "text-sm text-grey-darker" },
        React.createElement("strong", null, display_text),
        sortElement));
};
export const masterAccountFormatter = (cell) => {
    if (!cell)
        return 'NA';
    return cell;
};
const serviceWatchList = ['Service Watch', 'New Customer'];
export const serviceWatchFormatter = (cell) => {
    const text = cell || 'NA';
    let color;
    if (serviceWatchList.includes(cell)) {
        color = 'blue';
    }
    else {
        color = 'brand';
    }
    return (React.createElement(Translation, null, (t) => React.createElement(Badge, { color: color, text: t(sluggify(text)) })));
};
export const statusFormatter = (cell) => (React.createElement(Translation, null, (t) => React.createElement(Badge, { color: "green", text: titleize(t(sluggify(cell))) })));
export const accessorialStatusFormatter = (cell) => {
    let color;
    switch (cell) {
        case 'pending':
            color = 'yellow';
            break;
        case 'approved':
            color = 'brand';
            break;
        case 'cancelled':
            color = 'gray';
            break;
        default:
            color = 'purple';
    }
    return React.createElement(Badge, { color: color, size: "large", rounded: true });
};
export function dateTimeFormatter(cell, _row, _rowIndex, extra) {
    return moment(cell).format('L LT');
}
const renderDatetimeRange = (startStr, endStr, timezone) => {
    if (!startStr || !endStr) {
        return i18next.t('NEEDS_APPOINTMENT');
    }
    const dateFormat = 'L';
    const timeFormat = 'LT';
    const dateFormatter = (momentObj) => {
        return momentObj.format(dateFormat);
    };
    const timeFormatter = (momentObj) => {
        return momentObj.format(timeFormat);
    };
    const start = moment(startStr);
    let end;
    if (endStr) {
        end = moment(endStr);
    }
    let startWithTz;
    let endWithTz;
    let formattedTimezone = '';
    if (timezone) {
        startWithTz = start.clone().tz(timezone);
        if (end) {
            endWithTz = end.clone().tz(timezone);
        }
        formattedTimezone = getTimeZoneName(timezone);
    }
    else {
        startWithTz = start.clone();
        if (end) {
            endWithTz = end.clone();
        }
    }
    const startDate = dateFormatter(startWithTz);
    const startTime = timeFormatter(startWithTz);
    if (end && start.diff(end) === 0) {
        return (React.createElement("div", { className: "nowrap" },
            startDate,
            React.createElement("br", null),
            startTime,
            " ",
            formattedTimezone));
    }
    if (end && start.dayOfYear() === end.dayOfYear()) {
        let endTime;
        if (end) {
            endTime = timeFormatter(endWithTz);
        }
        return (React.createElement("div", { className: "nowrap" },
            startDate,
            React.createElement("br", null),
            startTime,
            " ",
            React.createElement("span", null, "-"),
            " ",
            endTime,
            ' ',
            React.createElement("strong", { style: { color: '#21B88E' } }, formattedTimezone)));
    }
    let endDate;
    let endTime;
    if (end) {
        endDate = dateFormatter(endWithTz);
        endTime = timeFormatter(endWithTz);
    }
    return (React.createElement("div", { className: "nowrap" },
        React.createElement("div", null,
            startDate,
            React.createElement("br", null),
            startTime),
        React.createElement("span", null, "-"),
        React.createElement("div", null,
            endDate,
            React.createElement("br", null),
            endTime,
            ' ',
            React.createElement("strong", { style: { color: '#21B88E' } }, formattedTimezone))));
};
export const credentialFormatter = (_cell, row) => {
    if (row._type === 'Driver')
        return row.username;
    return row.email;
};
export const loadDetailsFormatter = (_cell, row) => {
    const rows = [];
    if (row.full_truckload) {
        rows.push(React.createElement("div", { key: "full-truckload-cell" }, "Truckload"));
    }
    _.each(row.loads, (l, i) => {
        rows.push(React.createElement("div", { key: i },
            React.createElement(LoadDimensionFormatter, { quantity: l.quantity, type: l.type, length: l.length, width: l.width, height: l.height, dimensional_units: l.dimensional_units })));
    });
    rows.push(React.createElement("div", { key: "load-weight" },
        React.createElement(LoadUnitFormatter, { weight: accounting.format(row.weight), weight_units: row.weight_units })));
    return React.createElement("div", null, rows);
};
export const datetimeRangeFormatter = (cell, row, rowIndex, extra) => {
    // default to LAX when there's no market
    let timezone = row.market ? row.market.timezone : 'America/Los_Angeles';
    let start = row.pickup_after;
    let end = row.pickup_by;
    let stop;
    let isAdmin = false;
    if (extra) {
        if (extra === null || extra === void 0 ? void 0 : extra.admin) {
            isAdmin = true;
        }
        if ((extra === null || extra === void 0 ? void 0 : extra.type) === 'deliver') {
            start = row.deliver_after;
            end = row.deliver_by;
            timezone = getLocationTimezone(row.destination) || timezone;
            stop = getDeliverStop(row);
        }
        else {
            timezone = getLocationTimezone(row.origin) || timezone;
            stop = getPickupStop(row);
        }
    }
    let canEditWindow = canEditAppointmentWindow(row, isAdmin);
    if ((extra === null || extra === void 0 ? void 0 : extra.isCarrier) && !isIntermodalShipmentType(row)) {
        canEditWindow = false;
    }
    const confirmed = !(stop || {}).appointment_unconfirmed;
    return (React.createElement("div", null,
        renderDatetimeRange(start, end, timezone),
        row.shipment_type === 'drayage' && (React.createElement(AppointmentConfirmationBadge, { confirmed: confirmed, hideText: true })),
        canEditWindow && (extra === null || extra === void 0 ? void 0 : extra.onWindowEdit) && (React.createElement("div", { className: "mt-4" },
            React.createElement("button", { type: "button", onClick: () => extra === null || extra === void 0 ? void 0 : extra.onWindowEdit(extra === null || extra === void 0 ? void 0 : extra.type, row) },
                React.createElement("div", { className: "flex items-center text-sm text-green hover:text-green-darker" },
                    React.createElement("i", { className: "mr-1 fa fa-calendar" }),
                    React.createElement(Translation, null, (t) => React.createElement("span", null, t('EDIT')))))))));
};
export const defaultFormatter = (cell) => {
    if (!cell) {
        return null;
    }
    return React.createElement("span", null, titleize(humanize(unescapeHTML(cell))));
};
export const booleanFormatter = (cell) => {
    return (React.createElement(Translation, null, (t) => React.createElement("span", null, cell === true ? t('YES') : t('NO'))));
};
export const dateFormatter = (cell, row, rowIndex, extra) => (React.createElement("span", null, cell ? moment(cell).format('L') : ''));
export const priceFormatter = (cell) => React.createElement("span", null,
    "$",
    cell);
export const customActionsFormatter = (extraProps) => (cell, row) => {
    if (!extraProps) {
        return null;
    }
    return (React.createElement("div", { className: "flex flex-wrap items-center actions" },
        extraProps.canEdit && (React.createElement("a", { href: "#", className: "mr-2", onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
                extraProps.onEdit(row);
            } },
            React.createElement("i", { className: "fa fa-pencil" }))),
        extraProps.canDelete && extraProps.onDelete && (React.createElement("a", { href: "#", onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
                extraProps.onDelete(row);
            } },
            React.createElement("i", { className: "fa fa-trash-o" })))));
};
export const entityFormatter = (cell) => (React.createElement("div", { className: "block overflow-hidden text-overflow-ellipsis" },
    React.createElement("a", { className: "" }, cell)));
export const equipmentOrderEntityFormatter = (cell) => (React.createElement("div", { className: "block overflow-hidden text-overflow-ellipsis" },
    React.createElement("a", { className: "" }, cell)));
export const objectIdTimestampFormatter = (cell, row) => {
    const dateFromObjectId = function (objectId) {
        return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
    };
    return React.createElement("span", null, moment(dateFromObjectId(row._id)).format('YYYY-MM-DD'));
};
const getColor = (actual, expected) => {
    const diff = Math.abs(actual - expected);
    if (diff >= 30)
        return 'danger';
    if (diff >= 20)
        return 'warning';
    return 'success';
};
export const slaFormatter = (cell, row) => {
    const actualColor = getColor(row.actual_progress_percentage, row.expected_progress_percentage);
    const actualNow = row.actual_progress_percentage < 25 ? 25 : row.actual_progress_percentage;
    const expectedColor = getColor(row.expected_progress_percentage, row.expected_progress_percentage);
    const expectedNow = row.expected_progress_percentage < 25
        ? 25
        : row.expected_progress_percentage;
    return (React.createElement(Translation, null, (t) => (React.createElement("div", null,
        React.createElement("span", { className: "font-bold text-grey-darker" }, t('ACTUAL')),
        React.createElement(ProgressBar, { striped: true, now: actualNow, label: `${row.actual_progress_percentage}%`, bsStyle: actualColor, style: { marginBottom: 5 } }),
        React.createElement("span", { className: "font-bold text-grey-darker" }, t('EXPECTED')),
        React.createElement(ProgressBar, { striped: true, now: expectedNow, label: `${row.expected_progress_percentage}%`, bsStyle: expectedColor })))));
};
export const rolesFormatter = (cell, row) => {
    if (!cell)
        return null;
    const roles = _.uniq(row.roles);
    return (React.createElement("div", { className: "md:flex md:flex-wrap md:-mx-1" }, roles.map((role) => {
        return (React.createElement("div", { className: "mb-2 md:px-1", key: role },
            React.createElement(Translation, null, (t) => React.createElement(Badge, { color: "blue", text: t(sluggify(role)) }))));
    })));
};
export const tagsFormatter = (cell, row) => {
    if (!cell)
        return null;
    const tags = mapTags(row.tags);
    return (React.createElement("div", null, tags.map((tag, i) => {
        const key = `${tag}-${i}`;
        return (React.createElement("div", { className: "mb-2", key: key },
            React.createElement(Badge, { text: tag })));
    })));
};
export const customerFormatter = (cell, row) => {
    var _a;
    let entityId = row._id;
    let customer;
    let field = row;
    if (cell && typeof cell === 'object') {
        field = cell;
        entityId = cell._id;
    }
    const showPortProIcon = field._type === 'Carrier' && 'portpro' in field && ((_a = field === null || field === void 0 ? void 0 : field.portpro) === null || _a === void 0 ? void 0 : _a.enabled);
    switch (field._type) {
        case 'Shipper':
            customer = unescapeHTML(`${field.company_name || ''}`);
            break;
        case 'Carrier':
            customer = unescapeHTML(`${field.name || ''}`);
            break;
        default:
            customer = `${field.first_name || ''} ${field.last_name || ''}`;
    }
    return (React.createElement("div", { className: "flex mx-1" },
        React.createElement("a", { className: "", href: `/users/${entityId}` }, titleize(humanize(decode(customer)))),
        React.createElement("div", { style: { flexGrow: 0, flexShrink: 0 }, className: "mx-1 basis-5" }, showPortProIcon ? (React.createElement(Translation, null, (t) => (React.createElement("img", { src: "/img/icons/portProLogo.png", className: "w-full", title: t('CARRIER_INTEGRATED_WITH_PORTPRO'), alt: t('CARRIER_INTEGRATED_WITH_PORTPRO') })))) : null)));
};
export const locationFormatter = (cell) => {
    if (!cell)
        return null;
    const name = cell.name ? cell.name : '';
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("label", { className: "mr-2 text-sm font-bold text-grey-darker" }, humanize(decode(name)))),
        React.createElement("span", { className: "mb-4" }, cell.address)));
};
export const referenceNumberFormatter = (cell) => {
    const referenceFields = {
        partnerShipmentId: 'Partner Shipment',
        work_order_number: 'Work Order Number',
        house_bill_number: 'House Bill',
        mg_load_id: 'MG Load ID',
        mo_number: 'MO Number',
        tracking_id: 'Tracking ID',
        seal_number: 'Seal #',
        delivery_order: 'Delivery Order',
        master_bol: 'Master Reference',
        pu_number: 'PU Number',
    };
    const uniqueCell = _.uniq(cell || [], function (item) {
        return item.value;
    });
    const referenceNumbers = uniqueCell
        .filter((r) => !r.hidden && Object.keys(referenceFields).indexOf(r.name) > -1)
        .map((refNum, i) => {
        var _a;
        const values = ((_a = refNum.value) === null || _a === void 0 ? void 0 : _a.match(/.{1,20}/g)) || []; // Split reference number values into 20 char chunks for display can prob do a max-width?
        return (React.createElement(Translation, null, (t) => (React.createElement("div", { key: i },
            React.createElement("label", { className: "font-bold text-grey-darker" }, t(sluggify(referenceFields[refNum.name]))),
            React.createElement("div", { className: "" }, values.map((value, idx) => (React.createElement("div", { key: idx },
                React.createElement("span", { className: "mb-1" }, value)))))))));
    });
    return React.createElement("div", null, referenceNumbers);
};
const getBadgeData = (_equipmentType) => {
    let badgeColor = 'blue';
    let badgeName = 'container';
    if (_equipmentType === 'chassis_number') {
        badgeColor = 'purple';
        badgeName = 'chassis';
    }
    if (_equipmentType === 'trailer_number') {
        badgeColor = 'grey';
        badgeName = 'trailer';
    }
    return { badgeColor, badgeName };
};
export const equipmentListFormatter = (cell) => {
    const referenceFields = {
        chassis_number: 'Chassis Number',
        equipment_id: 'Equipment ID',
        trailer_number: 'Trailer Number',
    };
    const uniqueCell = _.uniq(cell || [], function (item) {
        return item.value;
    });
    const referenceNumbers = uniqueCell
        .filter((r) => !r.hidden && Object.keys(referenceFields).indexOf(r.name) > -1)
        .map((refNum, i) => {
        var _a;
        const values = ((_a = refNum.value) === null || _a === void 0 ? void 0 : _a.match(/.{1,20}/g)) || []; // Split reference number values into 20 char chunks for display can prob do a max-width?
        const badgeData = getBadgeData(refNum.name);
        return (React.createElement(Translation, null, (t) => (React.createElement("div", { key: refNum.value, className: "flex items-center mb-2 space-x-1" },
            `${refNum.value}`,
            React.createElement(Badge, { color: badgeData.badgeColor }, t(sluggify(badgeData.badgeName)))))));
    });
    return React.createElement("div", null, referenceNumbers);
};
export const InvoiceFormatter = (cell) => {
    let invoiceSent = 'N/A';
    if (cell.length) {
        invoiceSent = 'No';
        const invoiceFlags = cell.map((invoice) => {
            return invoice.email_sent;
        });
        if (invoiceFlags.every((flag) => flag === true)) {
            invoiceSent = 'Yes';
        }
    }
    return React.createElement("div", null, invoiceSent);
};
export const createResourceFormatter = (resource) => (cell, row, rowIndex, extra) => {
    /* when a column displays a sub entity, you can specify
     * the sub entities display attribute in the column mappings.
     * example src/main/js/components/modules/equipment/Mapping.js ->
     * formatExtraData: {
     *   attribute: 'order_id',
     * },
     */
    const subEntityField = extra && (extra === null || extra === void 0 ? void 0 : extra.attribute) ? extra === null || extra === void 0 ? void 0 : extra.attribute : null;
    let entityId = typeof cell === 'object' ? (cell || {})._id : row._id;
    let isCreditMemo = row.credit_memos &&
        row.credit_memos.length &&
        cell === row.credit_memos[0].number;
    if (resource === 'invoices' && isCreditMemo) {
        entityId = row.credit_memos[0]._id;
    }
    if (extra && (extra === null || extra === void 0 ? void 0 : extra.entityIdField)) {
        entityId = row[extra === null || extra === void 0 ? void 0 : extra.entityIdField];
    }
    // Need either entityID to construct the link or extra?.onClick for custom handling.
    if (!(entityId || (extra && (extra === null || extra === void 0 ? void 0 : extra.onClick)))) {
        return null;
    }
    const field = cell && subEntityField ? cell[subEntityField] : cell;
    const link = `/${resource}/${entityId}`;
    if (extra && (extra === null || extra === void 0 ? void 0 : extra.onClick)) {
        return (React.createElement("div", { className: "flex flex-col justify-center items-center" },
            React.createElement("div", { className: "block overflow-hidden text-overflow-ellipsis mb-2" },
                React.createElement("a", { className: "", title: field, href: "#", onClick: (e) => extra === null || extra === void 0 ? void 0 : extra.onClick(row, e) }, field)),
            (extra === null || extra === void 0 ? void 0 : extra.showPreNoticeBadge) && showPreNoticeBadge(row)));
    }
    if (extra && (extra === null || extra === void 0 ? void 0 : extra.linkTarget)) {
        return (React.createElement("div", { className: "flex flex-col justify-center items-center" },
            React.createElement("div", { className: "block overflow-hidden text-overflow-ellipsis mb-2" },
                React.createElement("a", { className: "", title: field, href: link, target: extra === null || extra === void 0 ? void 0 : extra.linkTarget, rel: "noreferrer noopener" }, field)),
            (extra === null || extra === void 0 ? void 0 : extra.showPreNoticeBadge) && showPreNoticeBadge(row)));
    }
    return (React.createElement("div", { className: "flex flex-col justify-center items-center" },
        React.createElement("div", { className: "block overflow-hidden text-overflow-ellipsis" },
            React.createElement(ExternalLink, { title: field, href: link, showIcon: !!field })),
        (extra === null || extra === void 0 ? void 0 : extra.showPreNoticeBadge) && showPreNoticeBadge(row)));
};
export const genericFormatter = (cell) => React.createElement("span", null, cell);
export const documentsFormatter = (cell, row) => {
    return React.createElement(ShipmentListDocuments, { documents: cell, shipment: row });
};
export const getEntityFormatter = (type) => {
    switch (type) {
        case 'location':
            return createResourceFormatter('locations');
        case 'order':
            return createResourceFormatter('orders');
        case 'shipment':
            return createResourceFormatter('shipments');
        case 'customer':
            return createResourceFormatter('users');
        case 'invoice':
            return createResourceFormatter('invoices');
        case 'payout':
            return createResourceFormatter('payouts');
        default:
            return entityFormatter;
    }
};
const showPreNoticeBadge = (row) => {
    if (!row.pre_arrival ||
        !featureEnabled(CONFIGURED_FEATURES.AMAZON_PRE_ARRIVAL))
        return;
    return (React.createElement(Translation, null, (t) => React.createElement(Badge, { color: 'red', text: t(sluggify('PRE_NOTICE')) })));
};
